import AuthService from 'services/AuthService'

export default {
    handle(to, from, next) {
        AuthService.loadSession().then(() => next())
    },
}
